export const thunkTypes = {
  GET_SUMMARY: `summary/getSummary`,
};
